// extracted by mini-css-extract-plugin
export default {"wrapper":"aE-z","button":"bE-z","alternate":"cE-z","disabled":"dE-z","paymentWarning":"eE-z","fadeIn":"fE-z"};